import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppButton } from "./WhatsAppButton";
import { BackToTop } from "./BackToTop";
import { SoundFX } from "./SoundFX";
import { ScrollProgress } from "./ScrollProgress";

export const Layout = ({ children }) => (
  <>
    <ScrollProgress />
    <Navbar />
    <main>{children}</main>
    <Footer />
    <WhatsAppButton />
    <BackToTop />
    <SoundFX />
  </>
);
